export default __webpack_public_path__ + "static/media/lynnSocial.21af4a47.png";